import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name : 'formatDateFromString'})
export class FormatDateFromString implements PipeTransform{
    transform(value: any, ...args: any[]): any {
        if (!value){
            return " - ";
        }
        const tmp = new Date(value);
        return tmp.toLocaleDateString('fr-FR');
    }
}
